import { useState } from 'react';

import { useToastStore } from '@pkg/components/Toast/useToastStore';
import { useAppDispatch, useAppSelector, useUpdateUsername } from '@pkg/hooks';

import { updateBioChanges } from '@app/store/actions/yat-page-item-actions';
import { setYatPageBio, setYatPageHeading } from '@app/store/slices';

interface OlderPagesArg {
    eid?: string;
    newUsername?: string;
    newBio?: string;
    callbackUpdateBio?: () => void;
}

export function useHandleProfileData() {
    const [matchingUsername, setMatchingUsername] = useState<string>();

    const dispatch = useAppDispatch();
    const primaryYat = useAppSelector((state) => state.user?.primaryYat);
    const { mutateAsync: mutateUsername } = useUpdateUsername();

    const { addToast } = useToastStore();

    function updateOlderPages({ eid, newUsername, newBio, callbackUpdateBio }: OlderPagesArg) {
        // This dispatch is for v1 and v2 pages.
        dispatch(
            updateBioChanges({
                yat: eid || '',
                newUsername,
                newBio,
                callbackUpdateBio,
            }),
        );
    }

    function updateUsername(username: string) {
        addToast({
            isLoader: true,
            message: `Workin' on it...`,
        });

        mutateUsername({ value: { username } }).then((result) => {
            dispatch(setYatPageHeading(username));
            if (!result.ok && result.error && (result.status.code === 409 || result.status.code === 422)) {
                setMatchingUsername(username);
            }

            if (result.ok && result.value && result.value.user.username) {
                const { eid, username } = result.value.user;
                updateOlderPages({ eid, newUsername: username });
            }

            addToast({
                emoji: '💎',
                message: 'Username updated!',
            });
        });
    }

    function updateBio(bio: string) {
        addToast({
            isLoader: true,
            message: `Workin' on it...`,
        });

        updateOlderPages({
            eid: primaryYat,
            newBio: bio,
            callbackUpdateBio: () => {
                addToast({
                    emoji: '💎',
                    message: 'Bio updated!',
                });
            },
        });
        dispatch(setYatPageBio(bio));
    }

    return {
        matchingUsername,
        updateUsername,
        updateBio,
    };
}
